import { Output } from '@angular/core';

/**
 * 商品マスタ検索用PostDataSource
 * AG-Gridのフィルタ・ソート・ページネーションに対応したSpring API呼び出し
 */
export class ItemPostDataSource {
  private parent: any;
  private service: any;
  private resultKey: string;
  private querystrings: any;
  private init: boolean;

  @Output() errorMessage;

  public rowCount: any;
  private beforeRequest;
  private successCallback;

  constructor(params: any) {
    this.parent = params.parent;
    this.service = params.service;
    this.resultKey = params.resultKey;
    this.querystrings = params.querystrings;
    this.init = false;
    this.beforeRequest = params.beforeRequest;
    this.successCallback = params.successCallback;
  }

  getRows(params) {
    this.parent.working = true;

    // AG-Gridパラメータを検索パラメータに変換
    const searchParams: any = {
      startRow: params.startRow,
      endRow: params.endRow
    };

    // ソート条件
    if (params.sortModel && params.sortModel.length > 0) {
      searchParams.sortModel = params.sortModel;
    }

    // フィルタ条件
    if (params.filterModel && Object.keys(params.filterModel).length > 0) {
      searchParams.filterModel = params.filterModel;
    }

    // 追加のクエリ文字列（ownerIdなど）
    if (this.querystrings) {
      for (var i in this.querystrings) {
        searchParams[i] = this.querystrings[i];
      }
    }

    if (this.beforeRequest) {
      this.beforeRequest(params)
    }
    console.log('[ItemPostDataSource::getRows] params of getRows', searchParams);
    this.service
      .search(searchParams)
      .then(outputJson => {
        console.log('[ItemPostDataSource::getRows::then] Response', outputJson);
        this.init = true;
        this.parent.working = false;
        const rowsThisPage = outputJson[this.resultKey];
        const lastRow = outputJson.total;
        // call the success callback
        params.successCallback(rowsThisPage, lastRow);
        if (this.successCallback) {
          this.successCallback(rowsThisPage, lastRow)
        }
      })
      .catch(error => {
        this.parent.working = false;
        console.log(this.parent.commonService.getErrorMessage(error));
        this.errorMessage = this.parent.commonService.getErrorMessage(error);
        // エラー時もコールバックを呼ぶ（グリッドの状態をリセットするため）
        params.successCallback([], 0);
        if (this.successCallback) {
          this.successCallback([], 0)
        }
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/classes/dataSource/itemPostDataSource.ts